import { render, staticRenderFns } from "./FlagshipGoalsWizardAdjustGoals.vue?vue&type=template&id=afee8a38&scoped=true&"
import script from "./FlagshipGoalsWizardAdjustGoals.vue?vue&type=script&lang=ts&"
export * from "./FlagshipGoalsWizardAdjustGoals.vue?vue&type=script&lang=ts&"
import style0 from "./FlagshipGoalsWizardAdjustGoals.vue?vue&type=style&index=0&id=afee8a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afee8a38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VForm,VImg,VRow,VSlider,VTextField})
